"use client";

import { useState } from "react";
import { Button } from "@mui/material";
import { ModalContextProvider } from "@/shared/Modal/ModalContextProvider";

export default function OpenModalDetailsButton({
  children,
}: {
  children: React.ReactNode;
}) {
  const [openModal, setOpenModal] = useState(false);

  const onClick = () => {
    setOpenModal(true);
  };

  return (
    <ModalContextProvider context={{ open: openModal, setOpen: setOpenModal }}>
      <Button variant="outlined" size="small" onClick={onClick}>
        Details
      </Button>

      {openModal && children}
    </ModalContextProvider>
  );
}
